module.exports = __webpack_public_path__ + "static/media/intro-mob.025dc744.svg";